if (!customElements.get('profit-calculator')) {
  class ProfitCalculator extends HTMLElement {
    connectedCallback() {
      // Tier pricing from data attributes
      this.tiers = [
        { min: parseInt(this.dataset.tier1Min, 10) || 1, price: parseFloat(this.dataset.tier1Price) || 0 },
        { min: parseInt(this.dataset.tier2Min, 10) || 8, price: parseFloat(this.dataset.tier2Price) || 0 },
        { min: parseInt(this.dataset.tier3Min, 10) || 20, price: parseFloat(this.dataset.tier3Price) || 0 }
      ];

      // Inputs
      this.casesInput = this.querySelector('[data-input="num-cases"]');
      this.casesRange = this.querySelector('[data-input="num-cases-range"]');
      this.bottlesInput = this.querySelector('[data-input="bottles-per-case"]');
      this.retailPriceInput = this.querySelector('[data-input="retail-price"]');

      // Tier badges
      this.tierBadges = this.querySelectorAll('.profit-calculator__tier-badge');

      // Outputs
      this.wholesaleCostEl = this.querySelector('[data-output="wholesale-cost"]');
      this.totalInvestmentEl = this.querySelector('[data-output="total-investment"]');
      this.profitPerBottleEl = this.querySelector('[data-output="profit-per-bottle"]');
      this.marginPercentEl = this.querySelector('[data-output="margin-percent"]');
      this.breakEvenEl = this.querySelector('[data-output="break-even"]');
      this.totalProfitEl = this.querySelector('[data-output="total-profit"]');

      this.bindEvents();
      this.calculate();
    }

    bindEvents() {
      // Sync range slider ↔ number input
      if (this.casesRange && this.casesInput) {
        this.casesRange.addEventListener('input', () => {
          this.casesInput.value = this.casesRange.value;
          this.calculate();
        });
        this.casesInput.addEventListener('input', () => {
          var val = parseInt(this.casesInput.value, 10);
          if (val >= 1 && val <= 50) this.casesRange.value = val;
          this.calculate();
        });
      }

      [this.bottlesInput, this.retailPriceInput].forEach((input) => {
        if (input) input.addEventListener('input', () => this.calculate());
      });
    }

    getTierForCases(cases) {
      // Walk tiers in reverse to find the highest matching tier
      for (var i = this.tiers.length - 1; i >= 0; i--) {
        if (cases >= this.tiers[i].min) return { index: i, price: this.tiers[i].price };
      }
      return { index: 0, price: this.tiers[0].price };
    }

    calculate() {
      var cases = Math.max(1, parseInt(this.casesInput.value, 10) || 1);
      var bottlesPerCase = Math.max(1, parseInt(this.bottlesInput.value, 10) || 1);
      var retailPrice = parseFloat(this.retailPriceInput.value) || 0;

      var tier = this.getTierForCases(cases);
      var wholesalePrice = tier.price;
      var totalBottles = cases * bottlesPerCase;
      var totalInvestment = totalBottles * wholesalePrice;
      var profitPerBottle = retailPrice - wholesalePrice;
      var marginPercent = retailPrice > 0 ? (profitPerBottle / retailPrice) * 100 : 0;
      var breakEven = retailPrice > 0 ? Math.ceil(totalInvestment / retailPrice) : 0;
      var totalRevenue = totalBottles * retailPrice;
      var totalProfit = totalRevenue - totalInvestment;

      // Update tier badges
      this.tierBadges.forEach(function(badge) {
        var badgeTier = parseInt(badge.dataset.tier, 10) - 1;
        badge.classList.toggle('profit-calculator__tier-badge--active', badgeTier === tier.index);
      });

      // Update outputs
      this.setOutput(this.wholesaleCostEl, this.formatCurrency(wholesalePrice));
      this.setOutput(this.totalInvestmentEl, this.formatCurrency(totalInvestment));
      this.setOutput(this.profitPerBottleEl, this.formatCurrency(profitPerBottle));
      this.setOutput(this.marginPercentEl, marginPercent.toFixed(1) + '%');
      this.setOutput(this.breakEvenEl, breakEven + ' of ' + totalBottles + ' bottles');
      this.setOutput(this.totalProfitEl, this.formatCurrency(totalProfit));
    }

    formatCurrency(amount) {
      return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    setOutput(el, value) {
      if (el) el.textContent = value;
    }
  }

  customElements.define('profit-calculator', ProfitCalculator);
}
